import { ValidatorFn, FormGroup } from '@angular/forms';

export function atLeastOneUBOValidator(): ValidatorFn {
    return (ubos: FormGroup): Record<string, boolean> | null => {
      const hasAtLeastOne = ubos && ubos.controls && Object.keys(ubos.controls).length > 0
  		return hasAtLeastOne ? null : { atLeastOneUBO: true };
    };
}
